import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import styles from './BirdsnestFilterBar.module.scss';
import filterIcon from '../../assets/icons/noun-filter-4800805 1.svg';
import { useIsMobile } from '../../utils/hooks';
import sortIcon from '../../assets/icons/XMLID_222_.svg';
import { useAlternativeLayout, getBorderTop } from '../../utils/liquidCustom';
export function BirdsnestFilterBar({ totalResults, sortOptions, currentSort, onSortChange, onFilterClick, showModelToggle = true, isModelView = true, onModelToggle, hideSort = false, runSearch, query = '', filters = {}, pageSize = 12, 
// true for sticky behavior, false for static behavior
sticky = false, }) {
    const [isSortOpen, setIsSortOpen] = useState(false);
    const sortRef = useRef(null);
    const filterBarRef = useRef(null);
    const currentSortOption = sortOptions.find(opt => opt.id === currentSort);
    const isMobile = useIsMobile(768);
    const useAlternativeLayoutValue = useAlternativeLayout();
    const borderTop = getBorderTop();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sortRef.current && !sortRef.current.contains(event.target)) {
                setIsSortOpen(false);
            }
        };
        if (isSortOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isSortOpen]);
    const handleSortSelect = (sortId) => {
        onSortChange(sortId);
        setIsSortOpen(false);
    };
    return (h("div", { ref: filterBarRef, class: `${styles.filterBar} ${!sticky ? styles.filterBarStatic : ''} ${!borderTop ? styles.filterBarNoBorder : ''}` },
        h("div", { class: styles.leftSection },
            h("button", { class: styles.filterBtn, onClick: onFilterClick, type: "button" },
                h("img", { src: filterIcon, alt: "Filter", class: styles.filterIcon }),
                h("span", { class: styles.filterBtnText }, isMobile ? 'filter & sort' : 'filter')),
            h("span", { class: styles.resultCount },
                totalResults,
                " ",
                useAlternativeLayoutValue ? "outfits" : "styles")),
        !useAlternativeLayoutValue && (h("div", { class: styles.rightSection },
            showModelToggle && (h("div", { class: styles.toggleContainer },
                h("span", { class: `${styles.toggleLabel} ${isModelView ? styles.active : ''}` }, "Model"),
                h("button", { class: styles.toggleSwitch, onClick: onModelToggle, type: "button", "aria-label": "Toggle between model and product view" },
                    h("span", { class: `${styles.toggleThumb} ${!isModelView ? styles.toggleRight : ''}` })),
                h("span", { class: `${styles.toggleLabel} ${!isModelView ? styles.active : ''}` }, "Product"))),
            !hideSort && (h("div", { class: styles.sortContainer, ref: sortRef },
                h("button", { class: styles.sortTrigger, onClick: () => setIsSortOpen(!isSortOpen), type: "button" },
                    h("span", { class: styles.sortLabel }, "SORT BY:"),
                    h("span", { class: styles.sortValue }, (currentSortOption === null || currentSortOption === void 0 ? void 0 : currentSortOption.label) || 'Best seller'),
                    h("img", { src: sortIcon, alt: "Sort", class: `${styles.sortArrow} ${isSortOpen ? styles.sortArrowUp : ''}` })),
                isSortOpen && (h("div", { class: styles.sortDropdownMenu }, sortOptions.map(option => (h("label", { key: option.id, class: `${styles.sortOption} ${option.id === currentSort ? styles.sortOptionSelected : ''}` },
                    h("span", { class: styles.radioWrapper },
                        h("input", { type: "radio", name: "sort", value: option.id, checked: option.id === currentSort, onChange: () => handleSortSelect(option.id), class: styles.radioInput }),
                        h("span", { class: styles.radioCustom }, option.id === currentSort && h("span", { class: styles.radioDot }))),
                    h("span", { class: styles.sortOptionLabel }, option.label))))))))))));
}
